var _path, _path2, _circle, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect10, _rect11, _rect12, _rect13, _circle4, _circle5, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 254,
    viewBox: "0 0 179 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.759 104C158.759 138.794 128.538 167 91.2588 167C53.9796 167 23.7588 138.794 23.7588 104C23.7588 69.2061 53.9796 41 91.2588 41C128.538 41 158.759 69.2061 158.759 104Z",
    fill: "url(#paint0_linear_3720_553)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7588 27H95.7588V43H85.7588V27Z",
    fill: "url(#paint1_linear_3720_553)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.7588,
    cy: 15,
    r: 14,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7588 172C131.523 172 163.759 142.003 163.759 105C163.759 82.6271 151.974 62.8154 133.867 50.6466C132.185 49.5167 130.187 48.9738 128.161 48.9738H55.3566C53.3308 48.9738 51.3322 49.5167 49.6508 50.6466C31.5431 62.8154 19.7588 82.6271 19.7588 105C19.7588 142.003 51.9943 172 91.7588 172Z",
    fill: "url(#paint2_linear_3720_553)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 156.973,
    y: 220.92,
    width: 41.9923,
    height: 7.75988,
    transform: "rotate(-150.054 156.973 220.92)",
    fill: "#565656"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 119.91,
    y: 206.62,
    width: 4.56438,
    height: 22,
    rx: 1,
    transform: "rotate(-150.054 119.91 206.62)",
    fill: "#242424"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 117.452,
    y: 201.742,
    width: 4.56438,
    height: 16,
    rx: 1,
    transform: "rotate(-150.054 117.452 201.742)",
    fill: "#242424"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 162.532,
    y: 205.785,
    width: 4.56438,
    height: 22,
    rx: 1,
    transform: "rotate(29.9461 162.532 205.785)",
    fill: "#242424"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 164.99,
    y: 210.663,
    width: 4.56438,
    height: 16,
    rx: 1,
    transform: "rotate(29.9461 164.99 210.663)",
    fill: "#242424"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 118.827,
    y: 204.842,
    width: 1.82575,
    height: 8,
    rx: 0.912877,
    transform: "rotate(-150.054 118.827 204.842)",
    fill: "#535353"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 116.37,
    y: 199.964,
    width: 1.82575,
    height: 7,
    rx: 0.912877,
    transform: "rotate(-150.054 116.37 199.964)",
    fill: "#535353"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 159.875,
    y: 225.027,
    width: 1.82575,
    height: 8,
    rx: 0.912877,
    transform: "rotate(-150.054 159.875 225.027)",
    fill: "#535353"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 154.422,
    y: 225.348,
    width: 1.82575,
    height: 7,
    rx: 0.912877,
    transform: "rotate(-150.054 154.422 225.348)",
    fill: "#535353"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5209,
    cy: 147.972,
    rx: 5.29423,
    ry: 9.92668,
    transform: "rotate(-44.9872 40.5209 147.972)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6175 157.846C54.3307 155.092 52.0653 148.461 46.5574 143.034C41.0496 137.608 34.3851 135.441 31.6718 138.195C28.9585 140.949 31.224 147.581 36.7318 153.007C42.2397 158.434 48.9042 160.6 51.6175 157.846ZM46.8857 154.316C48.6121 152.563 47.1706 148.344 43.666 144.891C40.1614 141.438 35.9208 140.059 34.1944 141.812C32.468 143.564 33.9095 147.784 37.4141 151.236C40.9187 154.689 45.1592 156.068 46.8857 154.316Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1865 150.876L47.8535 147.477L41.0556 140.143L37.3886 143.542L44.1865 150.876ZM17.0001 141.5L21.1443 138.703L17.0001 141.5ZM21.2434 115.081C22.1166 112.461 20.7009 109.63 18.0812 108.757C15.4614 107.883 12.6298 109.299 11.7566 111.919L21.2434 115.081ZM37.3886 143.542C34.8889 145.859 32.4297 146.54 30.1861 146.12C27.8177 145.676 24.5823 143.796 21.1443 138.703L12.8558 144.297C17.1953 150.726 22.4598 154.846 28.344 155.949C34.3529 157.075 39.8987 154.85 44.1865 150.876L37.3886 143.542ZM21.1443 138.703C18.95 135.452 18.046 133.913 17.8375 131.399C17.6006 128.542 18.2723 123.994 21.2434 115.081L11.7566 111.919C8.72749 121.006 7.45551 127.208 7.87177 132.226C8.31649 137.587 10.6627 141.048 12.8558 144.297L21.1443 138.703Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5295 150.524L47.8448 146.781L40.3591 140.151L37.0438 143.893L44.5295 150.524ZM15.9997 140L11.9148 142.883L15.9997 140ZM20.8886 117.048C21.4672 114.347 19.7473 111.69 17.0472 111.111C14.347 110.532 11.6891 112.252 11.1105 114.952L20.8886 117.048ZM11.1105 114.952C11.0564 115.205 11.0022 115.454 10.9481 115.698L20.7117 117.86C20.7706 117.594 20.8296 117.323 20.8886 117.048L11.1105 114.952ZM8.24058 126.324C8.09811 126.927 7.96775 127.533 7.85934 128.139L17.703 129.9C17.7708 129.521 17.8598 129.101 17.9727 128.623L8.24058 126.324ZM11.4123 142.158C11.5747 142.397 11.7422 142.639 11.9148 142.883L20.0845 137.117C19.9438 136.917 19.8103 136.725 19.6836 136.538L11.4123 142.158ZM11.9148 142.883C12.1178 143.171 12.3236 143.456 12.532 143.739L20.5787 137.801C20.4123 137.576 20.2475 137.347 20.0845 137.117L11.9148 142.883ZM23.8859 154.133C24.612 154.52 25.3595 154.869 26.1267 155.171L29.7886 145.865C29.4033 145.714 29.0026 145.529 28.5878 145.308L23.8859 154.133ZM43.684 151.426C43.9715 151.137 44.2534 150.836 44.5295 150.524L37.0438 143.893C36.8896 144.068 36.7375 144.23 36.5877 144.38L43.684 151.426Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2071 149.209C50.1451 147.155 48.5671 145.014 46.5574 143.034C43.4408 139.964 39.9538 137.937 37.0219 137.255L38.259 141.398C39.9741 141.954 41.9122 143.163 43.666 144.891C45.0723 146.276 46.1463 147.785 46.8168 149.209H51.2071Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5557,
    cy: 109.556,
    r: 10.625,
    transform: "rotate(-30.6263 18.5557 109.556)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.29423,
    cy: 9.92668,
    rx: 5.29423,
    ry: 9.92668,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 152.765 144.694)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.906 157.846C128.193 155.093 130.458 148.461 135.966 143.034C141.474 137.608 148.138 135.441 150.852 138.195C153.565 140.949 151.299 147.581 145.792 153.007C140.284 158.434 133.619 160.6 130.906 157.846ZM135.638 154.316C133.911 152.563 135.353 148.344 138.857 144.891C142.362 141.438 146.603 140.059 148.329 141.812C150.055 143.564 148.614 147.784 145.109 151.237C141.605 154.689 137.364 156.068 135.638 154.316Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.808 150.302L134.715 146.373L142.572 140.187L145.665 144.116L137.808 150.302ZM143.593 208.642C141.03 209.668 138.12 208.421 137.094 205.857C136.069 203.293 137.316 200.383 139.88 199.358L143.593 208.642ZM145.665 144.116C149.433 148.903 151.703 155.535 153.053 161.406C154.427 167.379 155 173.244 155 177L145 177C145 174.049 144.524 168.936 143.308 163.648C142.068 158.259 140.206 153.348 137.808 150.302L145.665 144.116ZM155 177C155 181.063 153.345 188.197 151.593 194.007C150.685 197.015 149.668 199.945 148.674 202.252C148.184 203.39 147.642 204.511 147.062 205.45C146.773 205.917 146.406 206.45 145.956 206.95C145.568 207.381 144.786 208.165 143.593 208.642L139.88 199.358C138.999 199.71 138.556 200.224 138.526 200.257C138.436 200.358 138.449 200.364 138.557 200.189C138.77 199.845 139.089 199.227 139.49 198.295C140.28 196.462 141.173 193.922 142.019 191.118C143.773 185.303 145 179.437 145 177L155 177Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.807 150.302L134.715 146.373L142.572 140.187L145.665 144.116L137.807 150.302ZM150 176L145 176L150 176ZM146.919 204.839C145.627 207.28 142.601 208.211 140.161 206.919C137.72 205.627 136.789 202.601 138.081 200.161L146.919 204.839ZM138.081 200.161C138.202 199.932 138.323 199.699 138.442 199.464L147.356 203.996C147.212 204.28 147.067 204.561 146.919 204.839L138.081 200.161ZM142.586 189C142.745 188.479 142.897 187.959 143.042 187.442L152.67 190.143C152.505 190.732 152.332 191.323 152.152 191.915L142.586 189ZM144.987 176.68C144.996 176.44 145 176.213 145 176L155 176C155 176.345 154.993 176.694 154.98 177.048L144.987 176.68ZM145 176C145 175.746 144.996 175.474 144.989 175.185L154.986 174.925C154.995 175.295 155 175.653 155 176L145 176ZM143.292 163.082C143.155 162.518 143.009 161.954 142.854 161.392L152.494 158.734C152.677 159.398 152.849 160.062 153.009 160.722L143.292 163.082ZM138.247 150.887C138.102 150.684 137.955 150.489 137.807 150.302L145.665 144.116C145.906 144.422 146.14 144.734 146.367 145.049L138.247 150.887Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.316 149.209C132.378 147.155 133.956 145.014 135.966 143.034C139.083 139.964 142.57 137.937 145.502 137.255L144.264 141.398C142.549 141.955 140.611 143.163 138.857 144.891C137.451 146.276 136.377 147.785 135.707 149.209H131.316Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.556,
    cy: 205.556,
    r: 10.625,
    transform: "rotate(-30.6263 138.556 205.556)",
    fill: "#86B8F3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 150,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 150,
    width: 1.5,
    height: 10.5,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 147,
    width: 1.5,
    height: 18,
    rx: 0.75,
    fill: "#5998E1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 74,
    width: 116,
    height: 61,
    rx: 30.5,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 116.5,
    r: 8.5,
    fill: "#72B2FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 116.5,
    r: 8.5,
    fill: "#72B2FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1487 59.0249C35.0218 57.7603 36.4278 56.9674 37.9616 56.8747L138.041 50.8234C139.575 50.7306 141.066 51.3483 142.085 52.4985L145.039 55.8325L31.618 62.6905L34.1487 59.0249Z",
    fill: "#F94B4B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.618 62.6905L145.039 55.8325L149.085 60.8895L28.1061 68.2044L31.618 62.6905Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1061 68.2044L149.085 60.8895V60.8895C150.643 63.1549 149.131 66.2536 146.386 66.4195L31.3388 73.3758C28.5928 73.5419 26.7539 70.6002 28.1061 68.2044V68.2044Z",
    fill: "#F94B4B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3720_553",
    x1: 91.2588,
    y1: 27,
    x2: 91.2588,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3720_553",
    x1: 91.2588,
    y1: 27,
    x2: 91.2588,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3720_553",
    x1: 91.7588,
    y1: 38,
    x2: 91.7588,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHard);
export default __webpack_public_path__ + "static/media/hard.625710ccf0f4ce4a2afeb3a14a5ecece.svg";
export { ForwardRef as ReactComponent };